import { h } from 'preact'
import classNames from 'clsx'

import LinkWrapper from '../../atom/link-wrapper'

import styles from './index.module.scss'

const TagList = (props) => {
  const { className, linkProps, entries = [] } = props

  return (
    <ul className={classNames(className, styles['m-tag-list'])}>
      {entries.map(tag => {
        const { className, ...props } = linkProps

        return (
          <li key={tag.id} className={styles['m-tag-list__entry']}>
            <LinkWrapper
              {...props}
              href={tag.permalink}
              className={classNames(className, styles['m-tag-list__link'])}
            >
              {tag.label}
            </LinkWrapper>
          </li>
        )
      })}
    </ul>)
}

export default TagList
